module.exports = __webpack_public_path__ + "static/media/SampleImage_ClassroomCoursesDetail_Feat.d89b5773.png";